export default {
	locale: 'cs',
	device: 'desktop'
}